module.exports = {
    // Debug Setting
    // SERVER_BASE_URL: 'http://127.0.0.1:8081'

    // Production Setting
    // SERVER_BASE_URL: 'http://143.233.226.110'
    SERVER_BASE_URL: 'http://road-safety.enirisst.gr'

}
